














































import NuxtSsrInstantsearch from './nuxt-ssr-instantsearch'
import SidebarPanel from './sidebar-panel'
import {
	AisInfiniteHits
	AisStateResults
} from 'vue-instantsearch'
export default

	# Register instantsearch components
	components: {
		AisInfiniteHits
		AisStateResults
		SidebarPanel
		NuxtSsrInstantsearch
	}

	props:

		# The index name to render
		indexName: String

		# An array of objects containing:
		# - title: The title of a refinement list
		# - attribute: See the attribute prop of AisRefinementList
		refinementLists: Array

		# A hash of refinement item keys with their label/title
		refinementItemTitles: Object

		# How many hits to show per page
		hitsPerPage:
			type: Number
			default: 12

		# Text to show when no results
		noResultsText:
			type: String
			default: 'No results have been found.'

		# The text shown above the sidebar
		sidebarTitleText:
			type: String
			default: 'Filter By'

		# The sidebar open icon
		sidebarOpenIconClass:
			type: String
			default: 'icon-filter'

		# The sidebar close icon
		sidebarCloseIconClass:
			type: String
			default: 'icon-close'

